module.exports = __webpack_public_path__ + "static/media/please_close_door.f35f673.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/FreshCabinet/mp3/please_close_door.mp3
// module id = OzXW
// module chunks = 1